"use client";

import { Button } from "@shared/ui.primitives";
import { formatPrice } from "@shared/utils.pricing";
import React from "react";

import { WishlistButton } from "../WishlistButton/WishlistButton";

import * as styles from "./ProductATB.css";

type ProductATBProps = {
  prices: {
    guest: number;
    member: number;
    typical: number;
  };
  customPrice?: string;
  handleWishlist: () => void;
  handleAddToBag: () => void;
  isInWishlist: boolean;
  context?: string;
  isMember: boolean;
  membershipInBag: boolean;
  currencySymbol: string;
};

export const ProductATB = React.forwardRef<HTMLDivElement, ProductATBProps>(
  (
    {
      prices,
      customPrice,
      handleWishlist,
      handleAddToBag,
      isInWishlist,
      context = "mobile",
      isMember,
      membershipInBag,
      currencySymbol
    },
    ref
  ) => {
    const price = isMember || membershipInBag ? prices.member : prices.guest;

    const formattedPrice = formatPrice(price, currencySymbol);

    const id = context === "desktop" ? "product-atb" : "mobile-product-atb";

    return (
      <div className={styles.productATBContainer} id={id} ref={ref}>
        <Button
          variant="primary"
          width="full"
          onClick={handleAddToBag}
          text={`Add to bag — ${customPrice ? customPrice : formattedPrice}`}
        />

        <WishlistButton
          isInWishlist={isInWishlist}
          handleWishlist={handleWishlist}
        />
      </div>
    );
  }
);
